export const autoWidthElements = (className, minWidth) => {
  const elements = [...document.getElementsByClassName(className)];
  elements.forEach(el => {
    if (el.clientWidth < minWidth) {
      el.style.width = `${minWidth}px`;
    }
  });
};
